<template>
  <div class="page-default">
    <div class="map-section">
      <div class="dashboard-map">
        <div class="map-body">
          <div class="mouseTrigger">
            <div class="map-filter-defects">
              <div class="dropdown-group">
                <div class="dropdown ml-2">
                  <button
                    id="dropdownMenuButton"
                    type="button"
                    class="btn btn-sm"
                    :class="!dateFilter ? 'btn-dark' : 'btn-primary'"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-placement="top"
                    title="Filter by Date"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                  >
                    <font-awesome-icon :icon="['far', 'calendar-alt']" />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success"
                      style="
                        font-size: 0.85em;
                        position: absolute;
                        top: 0.25em;
                        right: 0.25em;
                      "
                      v-if="dateFilter"
                    />
                  </button>
                  <div
                    id="dropdown-menu"
                    class="dropdown-menu px-2 bg-secondary"
                    @click.stop
                  >
                    <div
                      class="dropdown-item-text d-flex justify-content-between align-items-center px-0 pb-2"
                    >
                      <p
                        class="badge badge-primary mb-0 font-weight-normal p-2"
                      >
                        Filter by date
                      </p>
                      <button
                        class="btn btn-sm btn-link text-white p-0"
                        @click="dateFilter = null"
                      >
                        Clear
                      </button>
                    </div>
                    <v-date-picker
                      is-dark
                      class="inline-calendar"
                      v-model="dateFilter"
                      :model-config="{
                        type: 'string',
                        mask: 'YYYY-MM-DD',
                      }"
                      mode="date"
                      trim-weeks
                      is-range
                    />
                  </div>
                </div>
              </div>
              <div class="dropdown-group">
                <div class="dropdown" ref="mapDataDropdown">
                  <button
                    class="btn btn-sm btn-dark position-relative text-white"
                    type="button"
                    id="mapDataMenuButton"
                    data-placement="top"
                    title="Map Layers"
                    aria-haspopup="true"
                    :aria-expanded="dropdownActive == 'mapData'"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    @click="
                      dropdownActive == 'mapData'
                        ? (dropdownActive = '')
                        : (dropdownActive = 'mapData')
                    "
                  >
                    <span class="mr-1">Map Layers</span>
                    <font-awesome-icon
                      v-if="dropdownActive == 'mapData'"
                      class="text-white angle-icon ml-1"
                      :icon="['fas', 'angle-up']"
                    />
                    <font-awesome-icon
                      v-else
                      class="text-white angle-icon ml-1"
                      :icon="['fas', 'angle-down']"
                    />
                  </button>
                  <div
                    aria-labelledby="mapDataMenuButton"
                    class="dropdown-menu dropdown-map-data p-3"
                    :style="dropdownActive == 'mapData' ? 'display:block' : 'display:none'"
                    @click.stop
                  >
                    <!-- Features -->
                    <div class="d-flex align-items-center mb-2 flex-wrap">
                      <span class="text-secondary fs-8 text-uppercase mr-2" style="min-width:72px;">Features</span>
                      <button
                        type="button"
                        class="btn btn-sm mr-1 mb-1"
                        :class="layer.show ? 'btn-primary' : 'btn-outline-light'"
                        v-for="layer in layers.filter((l) => l.id !== 'defects')"
                        :key="`feat-${layer.id}`"
                        @click="layer.show = !layer.show; toggleLayerVisibility(layer)"
                      >
                        {{ layer.name }}
                      </button>
                    </div>

                    <!-- Defects from -->
                    <div class="d-flex align-items-center mb-2 pb-2 border-outline-dark-bottom flex-wrap">
                      <span class="text-secondary fs-8 text-uppercase mr-2" style="min-width:72px;">Defects from</span>
                      <button
                        type="button"
                        class="btn btn-sm mr-2 mb-1"
                        :class="allJalanTypesOn ? 'btn-primary' : 'btn-outline-light'"
                        @click="toggleAllJalanTypes"
                      >
                        All
                      </button>
                      <div class="btn-group btn-group-sm mb-1">
                        <button
                          type="button"
                          class="btn"
                          :class="jalanTypeFilter[opt.key] ? 'btn-primary' : 'btn-outline-light'"
                          v-for="opt in jalanTypeOptions"
                          :key="`jt-${opt.key}`"
                          @click="jalanTypeFilter[opt.key] = !jalanTypeFilter[opt.key]"
                        >
                          {{ opt.label }}
                        </button>
                      </div>
                    </div>

                    <!-- Layer set switch -->
                    <div class="d-flex align-items-center mb-2">
                      <span class="text-secondary fs-8 text-uppercase mr-2" style="min-width:72px;">Layer set</span>
                      <div class="btn-group btn-group-sm">
                        <button
                          type="button"
                          class="btn"
                          :class="activeLayerSet == 'Maintenance_Coverage' ? 'btn-primary' : 'btn-outline-light'"
                          @click="setActiveLayerSet('Maintenance_Coverage')"
                        >
                          Maintenance Coverage
                        </button>
                        <button
                          type="button"
                          class="btn"
                          :class="activeLayerSet == 'Work_Layer' ? 'btn-primary' : 'btn-outline-light'"
                          @click="setActiveLayerSet('Work_Layer')"
                        >
                          Work Layers
                        </button>
                      </div>
                    </div>

                    <!-- Matrix -->
                    <div class="matrix-scroll-wrap">
                      <div class="matrix-scroll" style="max-height:260px; overflow:auto;">
                      <table class="matrix-table text-white fs-8 mb-0">
                        <thead>
                          <tr>
                            <th
                              rowspan="2"
                              class="text-left district-header cursor-pointer"
                              @click="toggleMatrixAll"
                              title="Toggle all districts"
                            >
                              District
                            </th>
                            <th
                              :colspan="matrixColumns.length"
                              class="text-center type-group-header"
                            >
                              {{ matrixGroupHeader }}
                              <font-awesome-icon
                                v-if="matrixColumnsAreWork"
                                :icon="['fas', 'info-circle']"
                                class="ml-1 text-secondary cursor-pointer"
                                data-placement="top"
                                :title="workLegendText"
                                @mouseover="helper.showTooltip"
                                @mouseleave="helper.hideTooltip"
                              />
                            </th>
                          </tr>
                          <tr>
                            <th
                              class="text-center cursor-pointer col-header"
                              v-for="type in matrixColumns"
                              :key="`col-${type}`"
                              @click="toggleMatrixColumn(type)"
                              :title="`Toggle ${columnLabel(type)} across all districts`"
                            >
                              {{ columnLabel(type) }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="row in districtMatrix"
                            :key="row.id"
                            :class="{ 'matrix-locked': !row.assigned, 'matrix-row-on': isRowAllSelected(row) }"
                          >
                            <td
                              class="text-nowrap district-cell"
                              :class="{ 'cursor-pointer': row.assigned }"
                              @click="row.assigned && toggleDistrictRow(row)"
                            >
                              <font-awesome-icon v-if="!row.assigned" :icon="['fas', 'lock']" class="mr-1 text-muted" />
                              {{ row.name }}
                              <span v-if="!row.assigned" class="text-muted font-italic ml-1 fs-8">not assigned</span>
                            </td>
                            <td
                              class="text-center cell-toggle"
                              v-for="type in matrixColumns"
                              :key="`${row.id}-${type}`"
                              @click="toggleMatrixCell(row, type)"
                            >
                              <span v-if="!row.assigned" class="text-muted">&times;</span>
                              <span v-else-if="row[matrixSetKey][type] === undefined" class="text-muted">&mdash;</span>
                              <span
                                v-else
                                :class="row[matrixSetKey][type] ? 'text-primary' : 'text-muted'"
                              >{{ row[matrixSetKey][type] ? '●' : '○' }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="toggle-button-map border rounded">
              <button
                type="button"
                class="btn btn-sm btn-dark"
                @click="toggleMapStyle(!selectedMapStyle)"
                data-toggle="tooltip"
                data-placement="top"
                :title="
                  !selectedMapStyle
                    ? 'Switch to Satellite map style'
                    : 'Switch to Street map style'
                "
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              >
                <font-awesome-icon
                  class="small mr-1"
                  :icon="
                    !selectedMapStyle ? ['fas', 'satellite'] : ['fas', 'road']
                  "
                />
                {{ !selectedMapStyle ? "Satellite" : "Street" }}
              </button>
            </div>

            <div>
              <button
                class="btn bg-dashboard-dark-2 map-card-tip text-white py-3 pl-3 pr-2 cursor-pointer rounded-left"
                type="button"
                :style="!expandSummary ? 'right: 0rem' : `right: ${rightTip}`"
                @click="handleToggleSummary"
                data-toggle="tooltip"
                data-placement="left"
                title="Mini Dashboard"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              >
                <font-awesome-icon
                  class="cursor-pointer angle-icon fa-lg"
                  v-if="expandSummary"
                  :icon="['fas', 'angle-right']"
                />
                <font-awesome-icon
                  class="cursor-pointer angle-icon fa-lg"
                  v-if="!expandSummary"
                  :icon="['fas', 'angle-left']"
                />
              </button>
              <div
                class="map-card-dashboard fa-lg"
                :style="expandSummary ? 'right: 0px' : 'right: -195px'"
              >
                <div
                  class="map-card-content bg-dashboard-dark-2 shadow-sm border border-light"
                >
                  <div>
                    <div class="dropdown-group">
                      <div class="dropdown mt-2 mx-1">
                        <button
                          type="button"
                          data-placement="top"
                          title="Filter by Work Layer"
                          @mouseover="helper.showTooltip"
                          @mouseleave="helper.hideTooltip"
                          class="btn btn-sm btn-dark border-left-0 d-flex justify-content-between align-items-center rounded w-100"
                          @click="
                            visibleDropdownReportType =
                              !visibleDropdownReportType
                          "
                        >
                          <div>
                            {{ helper.changeLabelWorkLayer(reportTypeCase) }}
                          </div>
                          <div>
                            <font-awesome-icon
                              v-if="visibleDropdownReportType"
                              class="cursor-pointer ml-1 angle-icon"
                              :icon="['fas', 'angle-up']"
                            />
                            <font-awesome-icon
                              v-else
                              class="cursor-pointer ml-1 angle-icon"
                              :icon="['fas', 'angle-down']"
                            />
                          </div>
                        </button>
                        <div
                          class="dropdown-menu p-0"
                          style="max-height: 200px; overflow-y: auto"
                          :style="
                            visibleDropdownReportType
                              ? 'display: block'
                              : 'display: none'
                          "
                        >
                          <button
                            v-for="reportType in reportTypeArr"
                            :key="reportType.value"
                            class="dropdown-item btn-secondary d-flex justify-content-between align-items-center fs-8 px-3 py-2 border-outline-dark-bottom"
                            :class="
                              reportTypeCase == reportType.value
                                ? 'text-white'
                                : 'text-light'
                            "
                            @click="handleChangeReportType(reportType)"
                          >
                            <span
                              >{{
                                helper.changeLabelWorkLayer(reportType.label)
                              }}
                              <font-awesome-icon
                                :icon="['fas', 'check']"
                                class="text-primary ml-3 small"
                                v-if="reportTypeCase == reportType.value"
                            /></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="dropdown-divider my-3 border-top mx-1 border-outline-dark-bottom"
                  ></div>
                  <div class="mx-3">
                    <p
                      class="text-white text-center small mb-2 font-weight-bold fh-1"
                    >
                      Summary Case
                      {{
                        reportTypeCase != "All"
                          ? `/ ${helper.changeLabelWorkLayer(reportTypeCase)}`
                          : ""
                      }}
                    </p>

                    <div class="row">
                      <template v-for="(report, idx) in summaryReport">
                        <div
                          v-if="report.separatorBefore"
                          :key="`sep-${idx}`"
                          class="col-12 px-2 mt-2 mb-1"
                        >
                          <hr
                            class="my-0"
                            style="
                              border-top: 1px solid rgba(255, 255, 255, 0.4);
                            "
                          />
                        </div>
                        <div
                          :key="idx"
                          :class="idx == 0 ? 'col-12 p-0' : 'col-6 p-0'"
                        >
                        <div
                          class="text-center text-white p-1 rounded m-1"
                          style="cursor: pointer"
                          :class="report.color"
                          @click="
                            caseByStatus =
                              idx == 0 ? 'All' : report.tooltip || report.label
                          "
                          data-placement="left"
                          data-toggle="tooltip"
                          :title="`Filter by ${report.tooltip || report.label}`"
                          @mouseover="helper.showTooltip"
                          @mouseleave="helper.hideTooltip"
                        >
                          <h4
                            v-if="idx == 0"
                            class="font-weight-bold mb-0 text-white"
                          >
                            {{ report.value }}
                          </h4>
                          <h6 v-else class="font-weight-bold mb-0 text-white">
                            {{ report.value }}
                          </h6>
                          <p
                            style="font-size: 0.7rem"
                            class="small text-center mb-0 text-break text-white"
                          >
                            {{ report.label }}
                          </p>
                          <font-awesome-icon
                            :icon="['fas', 'check-circle']"
                            class="text-success bg-white rounded-circle"
                            style="
                              font-size: 0.8em;
                              position: absolute;
                              top: 0.05em;
                              right: 0.25em;
                            "
                            v-if="
                              caseByStatus ==
                              (report.label == 'Total Case'
                                ? 'All'
                                : report.label)
                            "
                          />
                        </div>
                      </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="map" class="bg-dashboard-dark-2"></div>
            <div
              class="btn map-legend cursor-pointer border border-bottom-0"
              data-toggle="tooltip"
              data-placement="top"
              title="Legend"
              @mouseover="helper.showTooltip"
              @mouseleave="helper.hideTooltip"
              :class="{ expand: expandLegend }"
              @click="expandLegend = !expandLegend"
            >
              <p
                class="px-3 font-weight-medium mb-0 d-flex justify-content-between align-items-center text-white"
              >
                Legend
                <font-awesome-icon
                  class="text-white angle-icon"
                  :icon="['fas', 'angle-down']"
                />
              </p>
              <div
                class="legend-body d-flex flex-column justify-content-start align-items-start text-white"
              >
                <div class="legend-item">
                  <div class="defect-marker mr-2 bg-danger"></div>
                  Open Case
                </div>
                <div class="legend-item">
                  <div class="defect-marker mr-2 bg-success"></div>
                  Closed Case
                </div>
                <div class="legend-item">
                  <div class="defect-marker mr-2 bg-warning"></div>
                  NOE Case
                </div>
                <div class="legend-item">
                  <div class="defect-marker mr-2 bg-primary"></div>
                  Tampalan PBT
                </div>
                <div class="legend-item">
                  <div
                    class="defect-marker mr-2 bg-danger border-success"
                    style="border: 3px solid green"
                  ></div>
                  Verified Defect
                </div>

                <div class="legend-item">
                  <img
                    src="@/assets/icons/marker.png"
                    alt="marker icon"
                    class="mr-2"
                    style="width: 1rem; height: 1rem"
                  />
                  Premix Plant
                </div>
                <div class="legend-item">
                  <img
                    src="@/assets/icons/water.png"
                    alt="marker icon"
                    class="mr-2"
                    style="width: 0.9rem; height: 1rem"
                  />
                  Flood Area
                </div>
                <div class="legend-item">
                  <div
                    class="route-line mr-2 shadow-sm"
                    style="background-color: #ff0000"
                  ></div>
                  Jalan Protocol
                </div>
                <div class="legend-item">
                  <div
                    class="route-line mr-2 shadow-sm"
                    style="background-color: #ffff00"
                  ></div>
                  Jalan Sekunder
                </div>
                <div class="legend-item">
                  <div
                    class="route-line mr-2 shadow-sm"
                    style="background-color: #00aa00"
                  ></div>
                  Jalan Utama
                </div>
                <div class="legend-item">
                  <div
                    class="route-line mr-2 shadow-sm"
                    style="background-color: #00ffff"
                  ></div>
                  Jalan Minor
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <media-preview
      :downloadImage="true"
      v-if="currentImage"
      :url="currentImage"
      @close="currentImage = null"
    />
    <spinner v-if="isProcessing" />
  </div>
</template>

<script>
import API from "@/api";
import axios from "axios";
import "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import $ from "jquery";
import moment from "moment";
import Spinner from "@/components/Spinner";
import Pin from "@/components/Pin";
import MediaPreview from "@/components/MediaPreview";
import Quarries from "@/quarries";
import BanjirGombak from "@/banjirGombak";
import BanjirHuluLangat from "@/banjirHuluLangat";
import BanjirHuluSelangor from "@/banjirHuluSelangor";
import BanjirKlang from "@/banjirKlang";
import BanjirKualaLangat from "@/banjirKualaLangat";
import BanjirPj from "@/banjirPj";
import Helper from "@/helper";
import banjir from "@/banjir.json";

const lastWeek = moment()
  .subtract(1, "week")
  .startOf("day")
  .format("YYYY-MM-DD");
const today = moment().endOf("day").format("YYYY-MM-DD");

export default {
  name: "defects",
  components: {
    Pin,
    spinner: Spinner,
    MediaPreview,
  },
  data() {
    return {
      dropdownActive: "",
      visibleDropdownReportType: false,
      helper: Helper,
      currentImage: null,
      selectedCaseItem: null,
      isProcessing: false,
      map: null,
      cases: [],
      districts: [],
      dateFilter: {
        start: lastWeek,
        end: today,
      },
      userDistricts: [],
      userRole: null,
      newBanjir: [
        ...BanjirPj,
        ...BanjirGombak,
        ...BanjirHuluLangat,
        ...BanjirHuluSelangor,
        ...BanjirKlang,
        ...BanjirKualaLangat,
      ],
      quarries: Quarries,
      maintenanceLayers: [],
      showMaintenanceGroup: {},
      workLayers: [],
      kmlDataSource: [],
      showWorkGroup: {},
      expandSummary: false,
      expandLegend: false,
      timeoutMouse: 0,
      timeoutSearch: 0,
      reportTypeArr: [
        {
          label: "All",
          value: "All",
        },
        {
          label: "KKE",
          value: "KKE",
        },
        {
          label: "R01",
          value: "R01",
        },
        {
          label: "R02",
          value: "R02",
        },
        {
          label: "R03",
          value: "R03",
        },
        {
          label: "R04",
          value: "R04",
        },
        {
          label: "R05",
          value: "R05",
        },
        {
          label: "R06",
          value: "R06",
        },
        {
          label: "R07",
          value: "R07",
        },
        {
          label: "R08",
          value: "R08",
        },
        {
          label: "R11",
          value: "R11",
        },
      ],
      layers: [
        {
          id: "defects",
          layer: "circle",
          name: "Defects",
          show: true,
        },
        {
          id: "quarry",
          layer: "quarryLayer",
          name: "Premix Plant",
          show: false,
        },
        {
          id: "banjir",
          layer: "banjirLayer",
          name: "Flood Area",
          show: false,
        },
      ],
      caseSource: [],
      reportTypeCase: "All",
      caseByStatus: "All",
      countCasesLoading: true,
      selectedMapStyle: false,
      rightTip: "195px",
      timeout: 0,
      countTime: 0,
      roadsData: {},
      roadDetails: [],
      roadMatchThresholdMeters: 150,
      abortController: null,
      closedClassById: {},
      closedBucketMap: {
        "Within 24h": "within24h",
        "Over 24h": "over24h",
        "Date anomaly": "anomaly",
      },
      districtMatrix: [],
      activeLayerSet: "Maintenance_Coverage",
      jalanTypeFilter: {
        protocol: true,
        secondary: true,
        primary: true,
        minor: true,
        other: true,
      },
      jalanTypeOptions: [
        { key: "protocol", label: "Protocol" },
        { key: "secondary", label: "Sekunder" },
        { key: "primary", label: "Utama" },
        { key: "minor", label: "Minor" },
        { key: "other", label: "Other" },
      ],
      markerMetaById: {},
    };
  },
  watch: {
    dateFilter: {
      handler(newVal) {
        $(".dropdown-toggle").dropdown("hide");
        if (newVal === null) {
          this.dateFilter = {
            start: moment().subtract(1, "week").startOf("day").format("YYYY-MM-DD"),
            end: moment().endOf("day").format("YYYY-MM-DD"),
          };
          return;
        }
        if (newVal && newVal.start && newVal.end) {
          this.removeMapResources();
          this.getCases();
        }
      },
      immediate: false,
    },
    caseByStatus: {
      handler() {
        this.updateDefectVisibility();
      },
      immediate: true,
    },
    reportTypeCase: {
      handler() {
        this.updateDefectVisibility();
      },
      immediate: true,
    },
    jalanTypeFilter: {
      handler() {
        this.updateDefectVisibility();
      },
      deep: true,
    },
  },
  computed: {
    allJalanTypesOn() {
      return this.jalanTypeOptions.every((o) => this.jalanTypeFilter[o.key]);
    },
    activeDistrictIds() {
      return new Set(
        this.districtMatrix.filter((d) => d.active).map((d) => String(d.id))
      );
    },
    summaryReport() {
      const activeIds = this.activeDistrictIds;
      // Scope counts to active districts. Fail OPEN for cases with no district
      // (e.g. before the backend ships the district field) so the summary mirrors
      // the map markers, which also fail open when district is unknown.
      const newData = this.caseSource.filter(
        (x) => !x.district || activeIds.has(String(x.district.id))
      );
      const filterBygroup =
        this.reportTypeCase != "All"
          ? newData.filter((x) => x.reportType == this.reportTypeCase)
          : newData;
      const openCase = filterBygroup.filter(
        (x) => x.status != "solved" && x.category != "Tampalan_PBT"
      );
      const closeCase = filterBygroup.filter(
        (x) => x.status == "solved" && x.category != "Tampalan_PBT"
      );
      const noeCase = filterBygroup.filter((x) => x.isNoe);
      const tampalanCase = filterBygroup.filter(
        (x) => x.category == "Tampalan_PBT"
      );
      const within24hCase = closeCase.filter(
        (x) => this.closedClass(x) === "within24h"
      );
      const over24hCase = closeCase.filter(
        (x) => this.closedClass(x) === "over24h"
      );
      const anomalyCase = closeCase.filter(
        (x) => this.closedClass(x) === "anomaly"
      );

      return [
        {
          label: "Total Case",
          color: "bg-dark-ds",
          value: openCase.length + closeCase.length,
        },
        {
          label: "Open",
          color: "bg-danger",
          value: openCase.length,
          tooltip: "Open Case",
        },
        {
          label: "Closed",
          color: "bg-success",
          value: closeCase.length,
          tooltip: "Closed Case",
        },
        {
          label: "NOE",
          color: "bg-warning-2",
          value: noeCase.length,
          tooltip: "NOE",
        },
        {
          label: "Tampalan",
          color: "bg-primary border border-light",
          value: tampalanCase.length,
          tooltip: "Tampalan PBT",
        },
        {
          label: "Within 24h",
          color: "bg-success",
          value: within24hCase.length,
          tooltip: "Within 24h",
          separatorBefore: true,
        },
        {
          label: "Over 24h",
          color: "bg-warning-2",
          value: over24hCase.length,
          tooltip: "Over 24h",
        },
        {
          label: "Date anomaly",
          color: "bg-secondary",
          value: anomalyCase.length,
          tooltip: "Date anomaly",
        },
      ];
    },
    matrixSetKey() {
      return this.activeLayerSet === "Work_Layer" ? "work" : "maintenance";
    },
    matrixColumns() {
      const list =
        this.activeLayerSet === "Work_Layer"
          ? this.workLayers
          : this.maintenanceLayers;
      return [...new Set(list.map((l) => l.type))].sort();
    },
    matrixColumnsAreWork() {
      return (
        this.matrixColumns.length > 0 &&
        this.matrixColumns.every(
          (t) => Helper.changeLabelWorkLayer(t) !== undefined
        )
      );
    },
    matrixGroupHeader() {
      return this.matrixColumnsAreWork ? "Work Layer" : "Type of Road";
    },
    workLegendText() {
      return this.matrixColumns
        .map((t) => Helper.changeLabelWorkLayer(t) || t)
        .join(" · ");
    },
  },
  methods: {
    toggleAllJalanTypes() {
      const target = !this.jalanTypeOptions.every((o) => this.jalanTypeFilter[o.key]);
      this.jalanTypeOptions.forEach((o) => {
        this.jalanTypeFilter[o.key] = target;
      });
    },
    // Mutually-exclusive class for a Closed (non-Tampalan) case.
    // Returns "within24h" | "over24h" | "anomaly" | null.
    closedClass(cs) {
      if (!cs || cs.status !== "solved" || cs.category === "Tampalan_PBT")
        return null;
      if (!cs.solveDate) return "anomaly"; // missing close date
      // timestamp is an ISO datetime; solveDate is a Unix epoch in seconds
      const d = moment.unix(cs.solveDate).diff(moment(cs.timestamp), "hours");
      if (d < 0) return "anomaly"; // closed before opened
      return d <= 24 ? "within24h" : "over24h";
    },
    // Single source of truth for defect-marker visibility. A marker is visible
    // only when: it matches the status/report filters, AND its district row is
    // active, AND its Jalan-Type chip is on. (All Jalan-Type chips off = no
    // markers = the master "off" state.)
    updateDefectVisibility() {
      if (!this.map) return;
      const layers = this.map
        .getStyle()
        .layers.filter((layer) => layer.id.includes("circle-"));
      if (!layers || layers.length === 0) return;

      const closedBucket = this.closedBucketMap[this.caseByStatus];
      const activeIds = this.activeDistrictIds;

      layers.forEach((element) => {
        const id = element.id.split("-").pop();
        const meta = this.markerMetaById[id] || {};
        const statusReport = Helper.matchesStatusReport(
          element.id,
          this.caseByStatus,
          this.reportTypeCase,
          closedBucket,
          this.closedClassById[id]
        );
        // Fail open when a marker has no district metadata (e.g. before the
        // backend ships the district field, or a case with no district) so
        // markers are never silently lost; district gating applies once known.
        const districtOn = meta.districtId
          ? activeIds.has(String(meta.districtId))
          : true;
        const jalanOn =
          this.jalanTypeFilter[Helper.jalanTypeBucket(meta.roadType)] !== false;
        const visible = statusReport && districtOn && jalanOn;
        this.map.setLayoutProperty(
          element.id,
          "visibility",
          visible ? "visible" : "none"
        );
      });
    },
    // Mark that a district has data for a given layer type, with the default
    // on/off state (work layers default off, maintenance defaults on — mirror
    // today). Cell with no key = no data for that (district, type).
    setMatrixAvailability(layer, setKey) {
      const districtId = String(
        (layer.district && (layer.district._id || layer.district.id)) ||
          layer.district ||
          ""
      );
      const row = this.districtMatrix.find((d) => String(d.id) === districtId);
      if (!row) return;
      // Seed the default only once; preserve user toggles across re-draws
      // (map-style switch re-runs displayKML, which re-invokes this).
      if (row[setKey][layer.type] === undefined) {
        const defaultOn = setKey === "maintenance";
        this.$set(row[setKey], layer.type, defaultOn);
      }
    },
    // Set visibility of every KML line layer (route-*) from the matrix. A layer
    // shows only when its district row is active AND its (set, type) cell is on.
    // Both Work and Maintenance layers are evaluated, regardless of which set the
    // grid is currently editing.
    applyLayerSetVisibility() {
      if (!this.map) return;
      const apply = (list, setKey) => {
        list.forEach((l) => {
          if (!this.map.getLayer(l.layer)) return;
          const districtId = String(
            (l.district && (l.district._id || l.district.id)) || l.district || ""
          );
          const row = this.districtMatrix.find(
            (d) => String(d.id) === districtId
          );
          const on = !!(row && row[setKey][l.type]);
          this.map.setLayoutProperty(
            l.layer,
            "visibility",
            on ? "visible" : "none"
          );
        });
      };
      apply(this.workLayers, "work");
      apply(this.maintenanceLayers, "maintenance");
    },
    setActiveLayerSet(set) {
      this.activeLayerSet = set;
    },
    columnLabel(type) {
      // Work codes (R0x) show as-is. For road types, drop the "jalan_" prefix
      // (the "Type of Road" group header conveys it) to keep the table compact.
      if (this.matrixColumnsAreWork) return type;
      return Helper.snakeToTitleCase(type.replace(/^jalan_/i, ""));
    },
    // Single per-district toggle: flips the district on/off together with ALL
    // its layer cells in the current set. "On" = active + every cell on.
    toggleDistrictRow(row) {
      if (!row.assigned) return;
      const setKey = this.matrixSetKey;
      const keys = Object.keys(row[setKey]);
      if (keys.length === 0) {
        // No layers in this set for the district — toggle defects (active) only.
        row.active = !row.active;
      } else {
        const target = !keys.every((t) => row[setKey][t]);
        keys.forEach((t) => this.$set(row[setKey], t, target));
        row.active = target;
      }
      this.updateDefectVisibility();
      this.applyLayerSetVisibility();
    },
    // Highlight rule: a district is "all selected" only when active AND every
    // one of its current-set cells is on (layerless district → just active).
    isRowAllSelected(row) {
      if (!row.assigned) return false;
      const setKey = this.matrixSetKey;
      const keys = Object.keys(row[setKey]);
      return keys.length > 0 && keys.every((t) => row[setKey][t]);
    },
    toggleMatrixCell(row, type) {
      if (!row.assigned) return;
      const setKey = this.matrixSetKey;
      if (row[setKey][type] === undefined) return; // no data
      this.$set(row[setKey], type, !row[setKey][type]);
      this.applyLayerSetVisibility();
    },
    // Master toggle (District header): flip every assigned district fully on/off
    // (active + all current-set cells together).
    toggleMatrixAll() {
      const setKey = this.matrixSetKey;
      const rows = this.districtMatrix.filter((d) => d.assigned);
      const allOn = rows.every((d) => {
        const keys = Object.keys(d[setKey]);
        return keys.length === 0 ? true : keys.every((t) => d[setKey][t]);
      });
      const target = !allOn;
      rows.forEach((d) => {
        Object.keys(d[setKey]).forEach((t) => this.$set(d[setKey], t, target));
        d.active = target;
      });
      this.updateDefectVisibility();
      this.applyLayerSetVisibility();
    },
    // Column header: toggle this layer type across all assigned districts (current set).
    toggleMatrixColumn(type) {
      const setKey = this.matrixSetKey;
      const rows = this.districtMatrix.filter(
        (d) => d.assigned && d[setKey][type] !== undefined
      );
      if (rows.length === 0) return;
      const target = !rows.every((d) => d[setKey][type]);
      rows.forEach((d) => this.$set(d[setKey], type, target));
      this.applyLayerSetVisibility();
    },
    handleMapDataOutsideClick(e) {
      if (this.dropdownActive !== "mapData") return;
      const el = this.$refs.mapDataDropdown;
      if (el && !el.contains(e.target)) {
        this.dropdownActive = "";
      }
    },
    handleChangeReportType(reportType) {
      this.visibleDropdownReportType = !this.visibleDropdownReportType;
      this.reportTypeCase = reportType.value;
    },
    handleToggleSummary() {
      this.expandSummary = !this.expandSummary;

      const searchingBar = document.getElementsByClassName(
        "mapboxgl-ctrl-top-right"
      );

      if (searchingBar.length > 0) {
        searchingBar[0].style.display = !this.expandSummary ? "none" : "block";
        this.rightTip = `${searchingBar[0].scrollWidth >= 127 ? 195 : 195}px`;
      }
    },
    toggleMapStyle(style) {
      this.selectedMapStyle = style;
      const satelliteStyle = "mapbox://styles/mapbox/satellite-v9";
      const defaultStyle = "mapbox://styles/mapbox/dark-v11";
      this.map.setStyle(style ? satelliteStyle : defaultStyle);
      this.reDrawMarker();
    },
    toggleGroupVisibility(group, type) {
      this[`${type.toLowerCase()}Layers`]
        .filter((l) => l.type == group)
        .forEach((route) => {
          route.show =
            this[`show${type}Group`][group].show ||
            this[`show${type}Group`][group];

          this.toggleLayerVisibility(route);
        });
    },
    toggleLayerVisibility(layer) {
      if (layer.layer == "circle") {
        this.updateDefectVisibility();
      } else {
        this.map.setLayoutProperty(
          layer.layer,
          "visibility",
          layer.show ? "visible" : "none"
        );
      }
    },
    onPinSelected(caseItem) {
      this.selectedCaseItem = caseItem;
    },
    forwardGeocoder(query) {
      const matches = query?.match(
        /^[ ]*(?:Lat: )?(-?\d+\.?\d*)[, ]+(?:Lng: )?(-?\d+\.?\d*)[ ]*$/i
      );

      let customData = {};

      if (!matches) {
        customData = {
          features: this.roadsData.filter((data) =>
            data.properties.title?.toLowerCase().includes(query?.toLowerCase())
          ),
          type: "FeatureCollection",
        };
      } else {
        function coordinateFeature(lng, lat) {
          return {
            center: [lng, lat],
            geometry: {
              type: "Point",
              coordinates: [lng, lat],
            },
            place_name: "Lat: " + lat + " Lng: " + lng,
            properties: {
              title: "Lat: " + lat + " Lng: " + lng,
            },
            type: "Feature",
          };
        }

        const coord1 = Number(matches[1]);
        const coord2 = Number(matches[2]);
        const geocodes = [];

        if (coord1 < -90 || coord1 > 90) {
          geocodes.push(coordinateFeature(coord1, coord2));
        }

        if (coord2 < -90 || coord2 > 90) {
          geocodes.push(coordinateFeature(coord2, coord1));
        }

        if (geocodes.length === 0) {
          geocodes.push(coordinateFeature(coord1, coord2));
          geocodes.push(coordinateFeature(coord2, coord1));
        }

        customData["features"] = geocodes;
      }

      const matchingFeatures = [];

      if (customData.features !== undefined && customData.features.length > 0) {
        for (const feature of customData.features) {
          if (feature.geometry.coordinates[0] !== undefined) {
            feature["place_name"] = `${feature.properties.title}`;
            feature["matching_place_name"] = `${feature.properties.title}`;
            feature["center"] = feature.geometry.coordinates;
            feature["place_type"] = ["place"];
            matchingFeatures.push(feature);
          }
        }
      }

      return matchingFeatures;
    },
    async getRoadsData() {
      return new Promise((resolve) => {
        const url = `roadsOnly?lat_null=false&lng_null=false&daerah_null=false&_limit=-1`;

        API.get(url).then((response) => {
          this.roadsData = response.data
            .filter((item) => item.lat && item.lng)
            .map((item) => {
              return {
                type: "Feature",
                properties: {
                  title: `${item.name}, ${item.subdistrict}, ${item.district}`,
                },
                geometry: {
                  coordinates: [item.lng, item.lat],
                  type: "Point",
                },
              };
            });

          resolve();
        });
      });
    },
    // Unfiltered roads cache used only for the road-highlight click popup
    // (Task 4). Deliberately drops getRoadsData()'s lat/lng/daerah
    // null-filters (that filter exists for search relevance and would
    // silently exclude roads with incomplete geodata from ever being found
    // by the proximity match) but keeps the roadsOnly endpoint itself —
    // the default /roads route deep-populates every relation (Cases,
    // Dashcamvideos, Defects, Inspections, Project, Lives) per record,
    // ballooning a single record to ~145KB; across ~5000 roads that's
    // enough to exhaust the backend and break the tunnel for every other
    // request on the page. roadsOnly is a custom endpoint that returns
    // plain fields only, so it stays fast at full scale (~2.5MB total).
    async getRoadDetails() {
      const url = "roadsOnly?_limit=-1";

      try {
        const response = await API.get(url);
        this.roadDetails = response.data;
      } catch (err) {
        console.error(err);
        this.roadDetails = [];
      }
    },
    // Best-effort match: no foreign key exists between a road-highlight
    // line and a roads record (KML line names are free text from Google
    // Earth, not a foreign key), so this matches by district (exact, from
    // the layers relation) plus closest-vertex proximity (from the geometry
    // actually drawn on the map).
    findNearestRoadDetail(vertices, districtName) {
      const candidates = this.roadDetails.filter(
        (road) => road.district === districtName && road.lat && road.lng
      );

      let closest = null;
      let closestDistance = Infinity;

      candidates.forEach((road) => {
        vertices.forEach(([lng, lat]) => {
          const distance = Helper.distanceMeters(road.lat, road.lng, lat, lng);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = road;
          }
        });
      });

      return closest && closestDistance <= this.roadMatchThresholdMeters
        ? closest
        : null;
    },
    async initMap() {
      return new Promise((resolve) => {
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_KEY;
        this.map = new mapboxgl.Map({
          container: "map",
          style: "mapbox://styles/mapbox/dark-v11",
          center: [101.414161, 3.320954],
          zoom: 9,
        });

        this.map.on("load", async () => {
          const geocoder = new MapboxGeocoder({
            accessToken: process.env.VUE_APP_MAPBOX_KEY,
            localGeocoder: this.forwardGeocoder,
            localGeocoderOnly: true,
            zoom: 12,
            limit: 10,
            placeholder: "Enter search e.g. Shah Alam",
            mapboxgl: mapboxgl,
            marker: {
              color: "orange",
            },
          });

          this.map.addControl(geocoder);

          resolve();
        });
      });
    },
    addQuarryMarker() {
      return new Promise((resolve) => {
        this.map.loadImage(
          require("@/assets/icons/marker.png"),
          (err, image) => {
            if (err) {
              console.error(err);

              return;
            }

            this.map.addImage("quarry-marker", image);
          }
        );

        this.map.addSource("quarrySource", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: this.quarries.map((quarry) => {
              return {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: [quarry.lng, quarry.lat],
                },
                properties: {
                  title: quarry.name,
                },
              };
            }),
          },
        });

        this.map.addLayer({
          id: "quarryLayer",
          type: "symbol",
          source: "quarrySource",
          layout: {
            "icon-image": "quarry-marker",
            "text-field": ["get", "title"],
            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
            "text-size": 10,
            "text-offset": [0, 1.25],
            "text-anchor": "top",
            "icon-allow-overlap": true,
            "text-allow-overlap": true,
          },
          paint: {
            "text-color": "#ffffff",
            "text-halo-width": 1,
            "text-halo-color": "#000",
            "text-halo-blur": 1,
          },
        });

        resolve();
        this.map.setLayoutProperty("quarryLayer", "visibility", "none");
      });
    },
    viewCase(caseId) {
      this.$router.push({ name: "inbox", params: { id: caseId } });
    },
    loadKML() {
      return new Promise(async (resolve) => {
        let query = "layers?_limit=-1";

        if (this.userDistricts.length > 0) {
          query += `&district_in=${this.userDistricts
            .map((ud) => ud._id)
            .join("&district_in=")}`;
        }

        const response = await API.get(query);
        this.kmlDataSource = response.data;

        this.displayKML();
        resolve();
      });
    },
    removeMaintenanceResources() {
      const layers = this.map
        .getStyle()
        .layers.filter((layer) => layer.id.includes("route-"));

      const sources = Object.keys(this.map.getStyle().sources).filter(
        (source) => source.includes("route-")
      );

      if (layers && layers.length > 0) {
        layers.forEach((layer) => {
          this.map.removeLayer(layer.id);
        });
      }

      if (sources && sources.length > 0) {
        sources.forEach((source) => {
          this.map.removeSource(source);
        });
      }
    },
    removeMapResources() {
      this.map.off(
        "click",
        this.selectedCaseItem,
        this.handleOnClickMarkerCircle
      );
      const layers = this.map
        .getStyle()
        .layers.filter((layer) => layer.id.includes("circle-"));

      layers.forEach((item) => {
        const data = this.map
          .getStyle()
          .layers.filter((layer) => layer.id.includes(item.id));

        const sources = Object.keys(this.map.getStyle().sources).filter(
          (source) => source.includes(item.id)
        );

        if (data && data.length > 0) {
          layers.forEach((layer) => {
            this.map.removeLayer(layer.id);
          });
        }

        if (sources && sources.length > 0) {
          sources.forEach((source) => {
            this.map.removeSource(source);
          });
        }
      });

      if (this.map.getLayer("circles-verified")) {
    this.map.removeLayer("circles-verified");
      }
      if (this.map.getSource("circles-verified")) {
        this.map.removeSource("circles-verified");
      }
    },
    async getCases() {
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      this.isProcessing = true;

      this.cases = [];

      let url =
        "cases/defects?timestamp_null=false&_sort=timestamp:DESC&_limit=-1&source_ne=socialMedia";

      url += `&reportType_nin=Tender`;

      if (this.reportTypeCase != "All") {
        url += `&reportType=${this.reportTypeCase}`;
      } else {
        url += "&reportType_nin=R09";
      }

      if (this.userDistricts.length > 0) {
        url += `&district_in=${this.userDistricts
          .map((ud) => ud._id)
          .join("&district_in=")}`;
      }

      if (this.dateFilter && this.dateFilter.start && this.dateFilter.end) {
        const _dateFilter = {
          start: moment(this.dateFilter.start).startOf("day").toISOString(),
          end: moment(this.dateFilter.end).endOf("day").toISOString(),
        };

        url += `&timestamp_gte=${_dateFilter.start}&timestamp_lte=${_dateFilter.end}`;
      } else {
        const defaultStart = moment().subtract(1, "week").startOf("day").toISOString();
        const defaultEnd = moment().endOf("day").toISOString();
        url += `&timestamp_gte=${defaultStart}&timestamp_lte=${defaultEnd}`;
      }

      if (this.caseByStatus == "Open Case") {
        url += `&status_ne=solved`;
      } else if (this.caseByStatus == "Closed Case") {
        url += `&status=solved`;
      } else if (this.caseByStatus == "NOE") {
        url += `&isNoe=true`;
      } else if (this.caseByStatus == "Tampalan PBT") {
        url += "&category=Tampalan_PBT";
      } else if (
        ["Within 24h", "Over 24h", "Date anomaly"].includes(this.caseByStatus)
      ) {
        url += `&status=solved`;
      }

      return API.get(url, null, { signal: this.abortController.signal })
        .then(async (retVal) => {
          this.countCasesLoading = false;
          if (this.caseByStatus == "All") {
            this.caseSource = retVal.data.filter(
              (caseItem) => caseItem.lat != null && caseItem.lng != null
            );
          }

          this.cases = retVal.data.filter(
            (caseItem) => caseItem.lat != null && caseItem.lng != null
          );

          if (this.closedBucketMap[this.caseByStatus]) {
            this.cases = this.cases.filter(
              (caseItem) =>
                this.closedClass(caseItem) ===
                this.closedBucketMap[this.caseByStatus]
            );
          }

          this.displayDefectMarkers();
          this.displayVerifiedDefectMarkers();
          this.updateDefectVisibility();

          this.isProcessing = false;
        })
        .catch((err) => {
          if (axios.isCancel(err)) return;
          console.error(err);

          this.isProcessing = false;
        });
    },
    viewImage(url) {
      this.currentImage = url;
    },
    async getDistricts() {
      this.isProcessing = true;

      // Fetch ALL districts (not just assigned) so the matrix can show locked
      // rows for unassigned districts. Data fetches stay scoped to userDistricts.
      const url = "districts?_sort=name";

      return API.get(url)
        .then((retVal) => {
          this.districts = retVal.data;
          this.districtMatrix = Helper.buildDistrictMatrix(
            retVal.data,
            this.userDistricts
          );

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    async generateNumber(id) {
      const response = await API.get(`cases/${id}`);
      return response.data.caseNumber && response.data.caseNumber;
    },
    displayKML() {
      this.removeMaintenanceResources();
      this.maintenanceLayers = [];
      this.showMaintenanceGroup = {};
      this.workLayers = [];
      this.showWorkGroup = {};

      if (this.kmlDataSource.length > 0) {
        this.kmlDataSource.forEach((layer, index) => {
          if (layer.type.includes("R0")) layer.show = false;
          else layer.show = true;

          layer.layer = `route-${layer.type}-${layer._id}`;

          if (layer.group == "Maintenance_Coverage") {
            this.maintenanceLayers.push(layer);
            this.setMatrixAvailability(layer, "maintenance");

            this.$set(this.showMaintenanceGroup, layer.type, true);

            const routeLayerId = `route-${layer.type}-${layer._id}`;

            // Fetched (not passed as a data: url) so MultiLineString
            // features can be split into one feature per sub-path before
            // Mapbox ever sees them — a MultiLineString can bundle many
            // physically disconnected sub-paths under one name, and
            // treating that bundle as a single hover/click unit highlights
            // everything in it instead of the specific segment clicked.
            // Plain fetch(), not API.get(): layer.file.url is already a
            // full URL (the same one Mapbox fetched directly before this
            // change), and API.get() unconditionally prefixes every URL
            // with the API base URL, which would break an already-absolute
            // URL.
            fetch(layer.file.url)
              .then((res) => res.json())
              .then((geojson) => {
                this.map.addSource(routeLayerId, {
                  type: "geojson",
                  data: Helper.explodeMultiLineStrings(geojson),
                  generateId: true,
                });

                this.map.addLayer({
                  id: routeLayerId,
                  type: "line",
                  source: routeLayerId,
                  layout: {
                    "line-join": "round",
                    "line-cap": "round",
                  },
                  paint: {
                    "line-color": ["get", "stroke"],
                    "line-width": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      ["+", ["get", "stroke-width"], 3],
                      ["get", "stroke-width"],
                    ],
                    "line-opacity": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      1,
                      ["get", "stroke-opacity"],
                    ],
                  },
                });

                // This layer only exists from this point on — the
                // forEach loop's own trailing applyLayerSetVisibility()
                // call runs before this fetch resolves, so it can't have
                // set this layer's visibility. Re-applying here (once per
                // layer, as each one finishes loading) is what actually
                // makes the Type-of-Road matrix take effect for it.
                this.applyLayerSetVisibility();

                // One Mapbox layer here holds every road segment in this
                // district+type file, so highlighting must target the single
                // hovered feature via feature-state, not the whole layer.
                let hoveredRoadFeatureId = null;

                this.map.on("mouseenter", routeLayerId, () => {
                  this.map.getCanvas().style.cursor = "pointer";
                });

                this.map.on("mousemove", routeLayerId, (e) => {
                  if (!e.features.length) return;

                  const featureId = e.features[0].id;
                  if (featureId === hoveredRoadFeatureId) return;

                  if (hoveredRoadFeatureId !== null) {
                    this.map.setFeatureState(
                      { source: routeLayerId, id: hoveredRoadFeatureId },
                      { hover: false }
                    );
                  }

                  hoveredRoadFeatureId = featureId;
                  this.map.setFeatureState(
                    { source: routeLayerId, id: hoveredRoadFeatureId },
                    { hover: true }
                  );
                });

                this.map.on("mouseleave", routeLayerId, () => {
                  this.map.getCanvas().style.cursor = "";

                  if (hoveredRoadFeatureId !== null) {
                    this.map.setFeatureState(
                      { source: routeLayerId, id: hoveredRoadFeatureId },
                      { hover: false }
                    );
                  }
                  hoveredRoadFeatureId = null;
                });

                this.map.on("click", routeLayerId, (e) => {
                  const feature = e.features[0];
                  const districtName =
                    (layer.district && layer.district.name) || "";
                  const roadType = Helper.snakeToTitleCase(
                    layer.type.replace(/^jalan_/i, "")
                  );

                  const vertices = Helper.flattenLineCoordinates(
                    feature.geometry
                  );
                  const match = this.findNearestRoadDetail(
                    vertices,
                    districtName
                  );

                  // feature.properties.name is not a per-road name — every
                  // sub-path in this file shares the same one arbitrary
                  // name left over from the file's original export, so it
                  // isn't shown at all. The only road name shown is the
                  // matched roads record's own name, which is tied to a
                  // real point rather than an entire district+type file.
                  let rows = `<tr>
                      <td class="text-white border-dark">District</td>
                      <td class="text-white border-dark">${districtName}</td>
                    </tr>
                    <tr>
                      <td class="text-white border-dark">Type</td>
                      <td class="text-white border-dark">${roadType}</td>
                    </tr>`;

                  if (match) {
                    if (match.name) {
                      rows =
                        `<tr>
                          <td class="text-white border-dark">Road Name</td>
                          <td class="text-white border-dark">${match.name}</td>
                        </tr>` + rows;
                    }
                    if (match.subdistrict) {
                      rows += `<tr>
                          <td class="text-white border-dark">Subdistrict</td>
                          <td class="text-white border-dark">${match.subdistrict}</td>
                        </tr>`;
                    }
                    if (match.lat) {
                      rows += `<tr>
                          <td class="text-white border-dark">Lat</td>
                          <td class="text-white border-dark">${match.lat}</td>
                        </tr>`;
                    }
                    if (match.lng) {
                      rows += `<tr>
                          <td class="text-white border-dark">Lng</td>
                          <td class="text-white border-dark">${match.lng}</td>
                        </tr>`;
                    }
                  }

                  const popupTitle = (match && match.name) || "Unknown Road";

                  const popupContainer = `<div class="mapbox-popup-container text-white">
                      <p class="popup-header text-white border-outline-dark-bottom">
                        ${popupTitle}
                      </p>
                      <div class="popup-content">
                        <table class="table table-striped table-sm mb-0">
                          ${rows}
                        </table>
                      </div>
                    </div>`;

                  new mapboxgl.Popup()
                    .setLngLat(e.lngLat)
                    .setHTML(popupContainer)
                    .addTo(this.map);
                });
              })
              .catch((err) => {
                console.error(err);
              });
          } else if (layer.group == "Work_Layer") {
            this.workLayers.push(layer);
            this.setMatrixAvailability(layer, "work");

            const workGroup = {
              show: false,
              color: Helper.colors(index),
            };

            this.$set(this.showWorkGroup, layer.district.name, workGroup);

            this.map.addSource(`route-${layer.type}-${layer._id}`, {
              type: "geojson",
              data: layer.file.url,
            });

            this.map.addLayer({
              id: `route-${layer.type}-${layer._id}`,
              type: "line",
              source: `route-${layer.type}-${layer._id}`,
              type: "circle",
              paint: {
                "circle-radius": 5,
                "circle-color": workGroup.color,
                "circle-opacity": 0.75,
                "circle-stroke-width": 0,
              },
              layout: {
                visibility: "none",
              },
            });

            this.map.on("click", `route-${layer.type}-${layer._id}`, (e) => {
              let gjsonFeatures = "";

              Object.keys(e.features[0].properties).forEach((feature) => {
                gjsonFeatures += `<tr>
                    <td class="text-white border-dark">${feature}</td>
                    <td class="text-white border-dark">${e.features[0].properties[feature]}</td>
                  </tr>`;
              });

              let popupContainer = `<div class="mapbox-popup-container text-white">
                  <p class="popup-header text-white border-outline-dark-bottom">
                    ${Helper.formatGeojsonName(layer.name)}
                  </p>
                  <div class="popup-content">
                    <table class="table table-striped table-sm mb-0">
                      ${gjsonFeatures}
                    </table>
                  </div>
                </div>`;

              new mapboxgl.Popup()
                .setLngLat(e.lngLat)
                .setHTML(popupContainer)
                .addTo(this.map);
            });

            this.map.on(
              "mouseenter",
              `route-${layer.type}-${layer._id}`,
              () => {
                this.map.getCanvas().style.cursor = "pointer";
              }
            );

            this.map.on(
              "mouseleave",
              `route-${layer.type}-${layer._id}`,
              () => {
                this.map.getCanvas().style.cursor = "";
              }
            );
          }
        });
      }
      this.applyLayerSetVisibility();
    },
    displayVerifiedDefectMarkers() {
      const features = this.cases
        .filter((c) => c.road && c.verifications && c.verifications.length > 0)
        .map((c) => {
          return {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [c.lng, c.lat],
            },
            properties: {
              id: c.id,
              imageUrl: c.media && c.media.length ? c.media[0].url : "",
              caption: c.caption,
              roadName: c.road.name,
              verifications: c.verifications
                .filter((v) => v.media.length > 0)
                .map((v) => v.media.map((m) => m.url))
                .flat(),
              coordinate: c.lat && c.lng ? [c.lat, c.lng] : [],
            },
          };
        });

      if (this.map.getLayer("circles-verified")) {
        this.map.removeLayer("circles-verified");
      }
      if (this.map.getSource("circles-verified")) {
        this.map.removeSource("circles-verified");
      }

      this.map.addSource("circles-verified", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features,
        },
      });

      this.map.addLayer({
        id: "circles-verified",
        source: "circles-verified",
        type: "circle",
        paint: {
          "circle-radius": 3,
          "circle-color": "#FA4147",
          "circle-opacity": 0.5,
          "circle-stroke-width": 2,
          "circle-stroke-color": "#04D15A",
        },
      });

      this.map.on("mouseenter", "circles-verified", () => {
        this.map.getCanvas().style.cursor = "pointer";
      });

      this.map.on("mouseleave", "circles-verified", () => {
        this.map.getCanvas().style.cursor = "";
      });

      this.map.on("click", "circles-verified", async (e) => {
        const props = e.features[0].properties;

        props.coordinate = JSON.parse(props.coordinate);

        const propVerifications = JSON.parse(props.verifications);

        let verificationImages = "";
        const caseNumber = await this.generateNumber(props.id);
        if (propVerifications.length > 1) {
          let imageCols = "";

          propVerifications.forEach((e) => {
            imageCols += `
              <div class="col-6 px-1 pb-1">
                <div class="embed-responsive embed-responsive-4by3 bg-light border">
                  <img class="defect-thumbnail embed-responsive-item clickable mb-0" src="${e}" />
                </div>
              </div>
            `;
          });

          verificationImages = `
            <div class="row mx-n1" style="height: calc(100% - 14px - 0.5rem)">
              ${imageCols}
            </div>
          `;
        } else if (propVerifications.length == 1) {
          verificationImages = `
            <div class="w-100 pb-1" style="height: calc(100% - 14px - 0.5rem)">
              <img class="defect-thumbnail clickable mb-0" src="${propVerifications[0]}" />
            </div>
          `;
        }

        let coordinateLink =
          props.coordinate.length == 2
            ? `<div class="mb-cap">
              <a class="btn btn-link p-0" href="https://maps.google.com/?q=${
                props.coordinate[0]
              },${props.coordinate[1]}" target="_blank">
                ${Helper.formatCoordinate(props.coordinate)}
              </a>
            </div>`
            : "";

        const html = `
					<div class="mb-popup">
            <div class="row mx-0">
              <div class="col pl-0 pr-1">
                <p class="mb-1 badge badge-danger">Defect Image</p>
                <div class="w-100 pb-1" style="height: calc(100% - 14px - 0.5rem)">
                  <img class="defect-thumbnail clickable mb-0" src="${props.imageUrl}" />
                </div>
              </div>
              <div class="col pl-1 pr-0">
                <p class="mb-1 badge badge-success">Verification Image</p>
                ${verificationImages}
              </div>
            </div>
						<div class="mb-cap pt-3">
              <a class="text-white" href="${window.location.origin}/#/cases/${caseNumber}" target="_blank">
                ${props.caption}
              </a>
            </div>
						<div class="mb-road text-light">${props.roadName}</div>
            ${coordinateLink}
					</div>
				`;

        new mapboxgl.Popup({
          maxWidth: "500px",
          closeButton: false,
          closeOnClick: true,
        })
          .setLngLat(e.lngLat)
          .setHTML(html)
          .on("open", () => {
            $(".defect-thumbnail").on("click", (e) => {
              this.viewImage(e.target.src);
            });
          })
          .on("close", () => {
            $(".defect-thumbnail").off("click");
          })
          .addTo(this.map);
      });
    },
    convertNameStatus(status) {
      if (status == "tampalan_pbt") {
        return "tampalan_pbt";
      } else if (status != "solved") {
        return "open";
      } else if (status == "solved") {
        return "closed";
      } else if (status == "noe") {
        return "noe";
      }
    },
    displayDefectMarkers() {
      // example source name = circle-status-R01-case_id
      this.closedClassById = {};
      this.markerMetaById = {};
      const newData = this.cases
        .filter(
          (c) =>
            (c.road || (c.category == "Tampalan_PBT" && !c.road)) &&
            (!c.verifications || c.verifications.length == 0)
        )
        .map((item) => {
          this.closedClassById[item.id] = this.closedClass(item);
          // cases/defects returns district as { id, name } — `id` is the
          // canonical field here (NOT `_id`); `_id` is only a defensive fallback.
          this.markerMetaById[item.id] = {
            districtId: item.district
              ? String(item.district.id || item.district._id)
              : null,
            roadType: item.road ? item.road.type : null,
          };
          return {
            name: `circle-${this.convertNameStatus(
              item.isNotify
                ? "notify"
                : item.isNoe
                ? "noe"
                : item.category == "Tampalan_PBT"
                ? "tampalan_pbt"
                : item.status
            )}-${item.reportType}-${item.id}`,
            color:
              item.category == "Tampalan_PBT"
                ? "#028EE6"
                : item.isNoe
                ? "#FD8326"
                : item.status != "solved"
                ? "#FA4147"
                : "#28a745",
            data: item,
          };
        });
      this.createMarker(newData);
    },
    createMarker(source) {
      const restoreLayer = (layerId) => {
        if (!this.map || !this.map.getLayer(layerId)) return;
        const isTampalan = layerId.startsWith("circle-tampalan_pbt");
        this.map.setPaintProperty(
          layerId,
          "circle-radius",
          isTampalan ? 5 : 6
        );
        this.map.setPaintProperty(
          layerId,
          "circle-stroke-width",
          isTampalan ? 1 : 0
        );
      };

      source.forEach((c) => {
        let obj = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [c.data.lng, c.data.lat],
          },
          properties: {
            id: c.data.id,
            mediaUrls: JSON.stringify(
              (c.data.media || []).map((m) => m.url).filter(Boolean)
            ),
            mediaDuringUrls: JSON.stringify(
              (c.data.media_during || []).map((m) => m.url).filter(Boolean)
            ),
            mediaAfterUrls: JSON.stringify(
              (c.data.media_after || []).map((m) => m.url).filter(Boolean)
            ),
            reportType: c.data.reportType || "",
            status: c.data.status || "",
            category: c.data.category || "",
            isNoe: !!c.data.isNoe,
            timestamp: c.data.timestamp || "",
            caption: c.data.caption,
            roadName: c.data.road?.name,
            coordinate:
              c.data.lat && c.data.lng ? [c.data.lat, c.data.lng] : [],
          },
        };

        this.map.addSource(c.name, {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [obj],
          },
        });

        this.map.addLayer({
          id: c.name,
          source: c.name,
          type: "circle",
          paint: {
            "circle-radius": c.data.category == "Tampalan_PBT" ? 5 : 6,
            "circle-color": c.color,
            "circle-opacity": 1,
            "circle-stroke-color": "#ffffff",
            "circle-stroke-width": c.data.category == "Tampalan_PBT" ? 1 : 0,
          },
          layout: {
            visibility: "visible",
          },
        });

        const isTampalan = c.data.category == "Tampalan_PBT";
        const baseRadius = isTampalan ? 5 : 6;
        const baseStroke = isTampalan ? 1 : 0;

        this.map.on("mouseenter", c.name, () => {
          // Clustered/overlapping dots fire mouseenter on every layer under
          // the cursor. Restore whichever was previously highlighted, then
          // take over — only one dot is highlighted at any moment.
          if (this._hoveredLayerId && this._hoveredLayerId !== c.name) {
            restoreLayer(this._hoveredLayerId);
          }
          this._hoveredLayerId = c.name;
          this.map.getCanvas().style.cursor = "pointer";
          this.map.setPaintProperty(c.name, "circle-radius", baseRadius + 2);
          this.map.setPaintProperty(c.name, "circle-stroke-width", 3);
        });

        this.map.on("mouseleave", c.name, () => {
          // Only restore when leaving the currently-highlighted layer —
          // mouseleave fires for every overlapping layer otherwise.
          if (this._hoveredLayerId !== c.name) return;
          this._hoveredLayerId = null;
          this.map.getCanvas().style.cursor = "";
          this.map.setPaintProperty(c.name, "circle-radius", baseRadius);
          this.map.setPaintProperty(c.name, "circle-stroke-width", baseStroke);
        });

        this.map.on("click", c.name, this.handleOnClickMarkerCircle);
      });
    },
    displaySelectedDefectMarksers() {
      let arrays = [
        "circles-open-case",
        "circles-closed-case",
        "circles-noe-case",
      ];
      arrays.forEach((element) => {
        if (this.caseByStatus == "Open Case") {
          this.map.setLayoutProperty(
            element,
            "visibility",
            element == "circles-open-case" ? "visible" : "none"
          );
        } else if (this.caseByStatus == "Closed Case") {
          this.map.setLayoutProperty(
            element,
            "visibility",
            element == "circles-closed-case" ? "visible" : "none"
          );
        }
      });
    },
    async handleOnClickMarkerCircle(e) {
      // Each case has its own Mapbox layer, so clustered/overlapping dots
      // fire `click` on every layer under the cursor. We want the popup to
      // match the dot the user actually sees on top — bail unless this
      // handler's feature is the visually topmost circle at the click point.
      const stack = this.map.queryRenderedFeatures(e.point);
      const topCircle = stack.find(
        (f) =>
          f.layer &&
          f.layer.id &&
          f.layer.id.indexOf("circle-") === 0 &&
          f.layer.id !== "circles-verified"
      );
      if (!topCircle || topCircle.layer.id !== e.features[0].layer.id) return;

      // Replace any previously open popup before opening a new one — avoids
      // a brief flash where two popups coexist on a fresh click.
      if (this._activePopup) {
        this._activePopup.remove();
        this._activePopup = null;
      }

      const props = e.features[0].properties;

      props.coordinate = JSON.parse(props.coordinate);

      this.onPinSelected(e.features[0].layer.id);
      const caseNumber = await this.generateNumber(props.id);

      let url =
        this.userRole != "JKR District"
          ? `${window.location.origin}/#/cases/${caseNumber}`
          : `${window.location.origin}/#/tenders`;

      let coordinateLink =
        props.coordinate.length == 2
          ? `<a class="mb-coord-pill" href="https://www.google.com/maps/place/${
              props.coordinate[0]
            },${props.coordinate[1]}/@${props.coordinate[0]},${
              props.coordinate[1]
            },18z" target="_blank" rel="noopener" title="Open in Google Maps">
              <svg class="mb-coord-pin" viewBox="0 0 24 24" width="12" height="14" aria-hidden="true"><path fill="#EA4335" stroke="#B31412" stroke-width="0.6" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5" fill="#fff"/></svg>
              <span>${Helper.formatCoordinate(props.coordinate)}</span>
            </a>`
          : "";

      const parseUrls = (raw) => {
        try {
          const arr = JSON.parse(raw || "[]");
          return Array.isArray(arr) ? arr : [];
        } catch (_) {
          return [];
        }
      };
      const beforeUrls = parseUrls(props.mediaUrls);
      const duringUrls = parseUrls(props.mediaDuringUrls);
      const afterUrls = parseUrls(props.mediaAfterUrls);

      const hasBefore = beforeUrls.length > 0;
      const hasDuring = duringUrls.length > 0;
      const hasAfter = afterUrls.length > 0;

      const statusBadge = (() => {
        if (props.category === "Tampalan_PBT")
          return { label: "Tampalan PBT", cls: "badge-primary" };
        if (props.isNoe === "true" || props.isNoe === true)
          return { label: "NOE", cls: "badge-warning" };
        if (props.status === "solved")
          return { label: "Closed", cls: "badge-success" };
        return { label: "Open", cls: "badge-danger" };
      })();

      const toggleBtn = (stage, label, enabled) =>
        `<button type="button"
          class="btn btn-sm ${enabled ? "btn-primary" : "btn-secondary"} stage-toggle"
          data-stage="${stage}" ${enabled ? "" : "disabled"}>${label}</button>`;

      const cell = (stage, label, badgeClass, urls) => {
        if (urls.length === 0)
          return `<div class="mb-stage-cell empty" data-cell="${stage}" style="display:none"></div>`;
        const hasMany = urls.length > 1;
        const urlsAttr = encodeURIComponent(JSON.stringify(urls));
        const counter = hasMany
          ? ` <span class="stage-counter">(1 of ${urls.length})</span>`
          : "";
        const chevronBar = hasMany
          ? `<div class="stage-chevron-bar">
               <button type="button" class="stage-chevron" data-dir="-1" aria-label="Previous">&#9664;</button>
               <button type="button" class="stage-chevron" data-dir="1" aria-label="Next">&#9654;</button>
             </div>`
          : "";
        return `<div class="mb-stage-cell" data-cell="${stage}" data-urls="${urlsAttr}" data-index="0">
          <p class="mb-1 badge ${badgeClass}">${label}${counter}</p>
          <div class="mb-stage-img-wrap">
            <img class="defect-thumbnail clickable" src="${urls[0]}" />
          </div>
          ${chevronBar}
        </div>`;
      };

      const dateChip = props.timestamp
        ? `<span class="mb-date-chip" title="${moment(props.timestamp).format(
            "DD MMMM YYYY, hh:mm A"
          )}">📅 ${moment(props.timestamp).format("D MMM YYYY")}</span>`
        : "";

      const html = `
        <div class="mb-popup mb-popup-multi">
          <div class="mb-popup-header d-flex justify-content-between align-items-stretch">
            <div class="mb-popup-meta pr-2">
              <a class="btn btn-link p-0 text-white text-left" href="${url}" target="_blank">
                ${props.caption}
              </a>
              <div class="mb-road text-light">${props.roadName || ""}</div>
              <div class="mb-popup-status d-flex align-items-center flex-wrap mt-1">
                <span class="badge ${statusBadge.cls}">${statusBadge.label}</span>
                <span class="small text-muted">Type: ${props.reportType || "—"}</span>
              </div>
            </div>
            <div class="mb-popup-right d-flex flex-column align-items-end flex-shrink-0">
              <div class="mb-popup-toggle-row d-flex align-items-center">
                ${dateChip}
                <div class="mb-popup-toggles btn-group btn-group-sm">
                  ${toggleBtn("before", "Before", hasBefore)}
                  ${toggleBtn("during", "During", hasDuring)}
                  ${toggleBtn("after", "After", hasAfter)}
                  <button type="button" class="btn btn-sm btn-dark stage-toggle-all">All</button>
                </div>
              </div>
              <div class="mb-popup-info d-flex align-items-center mt-auto">
                ${coordinateLink}
              </div>
            </div>
          </div>
          <div class="mb-popup-body d-flex mt-2">
            ${cell("before", "Before", "badge-danger", beforeUrls)}
            ${cell("during", "During", "badge-warning", duringUrls)}
            ${cell("after", "After", "badge-success", afterUrls)}
          </div>
        </div>
      `;

      const popup = new mapboxgl.Popup({
        maxWidth: "720px",
        closeButton: false,
        closeOnClick: true,
      })
        .setLngLat(e.lngLat)
        .setHTML(html)
        .on("open", () => {
          $(".defect-thumbnail").on("click", (e) => {
            this.viewImage(e.target.src);
          });

          $(".stage-toggle").on("click", (e) => {
            const $btn = $(e.currentTarget);
            if ($btn.is(":disabled")) return;
            const stage = $btn.data("stage");
            const willTurnOn = $btn.hasClass("btn-secondary");
            $btn.toggleClass("btn-primary btn-secondary");
            $(`[data-cell="${stage}"]`).toggle(willTurnOn);
          });

          $(".stage-toggle-all").on("click", () => {
            const $stages = $(".stage-toggle:not(:disabled)");
            const anyOff = $stages.is(".btn-secondary");
            $stages.each((_, btn) => {
              const $b = $(btn);
              const stage = $b.data("stage");
              $b.removeClass("btn-primary btn-secondary").addClass(
                anyOff ? "btn-primary" : "btn-secondary"
              );
              $(`[data-cell="${stage}"]`).toggle(anyOff);
            });
          });

          $(".stage-chevron").on("click", (e) => {
            e.stopPropagation();
            const $btn = $(e.currentTarget);
            const dir = parseInt($btn.data("dir"), 10) || 1;
            const $cell = $btn.closest(".mb-stage-cell");
            let urls;
            try {
              urls = JSON.parse(
                decodeURIComponent($cell.attr("data-urls") || "[]")
              );
            } catch (_) {
              urls = [];
            }
            if (!urls.length) return;
            let idx = parseInt($cell.attr("data-index"), 10) || 0;
            idx = (idx + dir + urls.length) % urls.length;
            $cell.attr("data-index", idx);
            $cell.find("img.defect-thumbnail").attr("src", urls[idx]);
            $cell
              .find(".stage-counter")
              .text(`(${idx + 1} of ${urls.length})`);
          });
        })
        .on("close", () => {
          $(".defect-thumbnail").off("click");
          $(".stage-toggle").off("click");
          $(".stage-toggle-all").off("click");
          $(".stage-chevron").off("click");
          if (this._activePopup === popup) {
            this._activePopup = null;
          }
        })
        .addTo(this.map);

      this._activePopup = popup;
    },
    loadKMLBanjir() {
      return new Promise((resolve) => {
        this.map.loadImage(
          require("@/assets/icons/water.png"),
          (err, image) => {
            if (err) {
              console.error(err);

              return;
            }

            this.map.addImage("banjir-marker", image);
          }
        );

        const newBanjir = this.newBanjir.map((banjir) => {
          return {
            id: "1.2.1",
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [banjir.lng, banjir.lat],
            },
            properties: {
              name: banjir.name,
            },
          };
        });

        let newData = {
          ...banjir[0],
          features: [...banjir[0].features, ...newBanjir],
        };

        this.map.addSource("banjirSource", {
          type: "geojson",
          data: newData,
        });

        this.map.addLayer({
          id: "banjirLayer",
          type: "symbol",
          source: "banjirSource",
          layout: {
            "icon-image": "banjir-marker",
            "text-field": ["get", "name"],
            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
            "text-size": 10,
            "text-offset": [0, 1.25],
            "text-anchor": "top",
            "icon-allow-overlap": true,
            "text-allow-overlap": true,
          },
          paint: {
            "text-color": "#ffffff",
            "text-halo-width": 1,
            "text-halo-color": "#000",
            "text-halo-blur": 1,
          },
        });

        resolve();
        this.map.setLayoutProperty("banjirLayer", "visibility", "none");
      });
    },
    reDrawMarker() {
      this.isProcessing = true;
      this.removeMapResources();
      this.removeMaintenanceResources();

      setTimeout(() => {
        this.displayDefectMarkers();
        this.displayVerifiedDefectMarkers();
        this.updateDefectVisibility();
        this.displayKML();
        this.addQuarryMarker();
        this.loadKMLBanjir();
        this.isProcessing = false;
      }, 1000);
    },
  },

  async mounted() {
    this.isProcessing = true;

    this._onKeyDown = (e) => {
      if (e.key !== "Escape") return;
      // Defer to MediaPreview if it's open — let it close first.
      if (this.currentImage) return;
      if (this._activePopup) {
        this._activePopup.remove();
        this._activePopup = null;
      }
    };
    document.addEventListener("keydown", this._onKeyDown, true);

    document.addEventListener("mousedown", this.handleMapDataOutsideClick);

    let _user = localStorage.getItem("user");

    if (_user) {
      _user = JSON.parse(_user);

      if (_user.districts && _user.districts.length > 0) {
        this.userDistricts = _user.districts.map((district) => {
          return {
            _id: district._id,
            name: district.name,
          };
        });
      }

      this.userRole = _user.role.name;
    }

    await this.getRoadsData();

    await this.getRoadDetails();

    await this.initMap();

    const searchingBar = document.getElementsByClassName(
      "mapboxgl-ctrl-top-right"
    );

    if (searchingBar.length > 0) {
      searchingBar[0].style.display = !this.expandSummary ? "none" : "block";
      this.rightTip = `${
        searchingBar[0].scrollWidth >= 127
          ? 195
          : searchingBar[0].scrollWidth + 38
      }px`;
    }

    // Districts MUST load before cases. getCases() builds the defect markers and
    // immediately computes their visibility against activeDistrictIds (derived
    // from districtMatrix). If the matrix is still empty here, every marker fails
    // the district check and stays hidden until a manual retoggle re-runs
    // updateDefectVisibility(). Build the matrix first so initial paint is correct.
    await this.getDistricts();

    await this.getCases();

    await this.loadKML();

    await this.addQuarryMarker();

    await this.loadKMLBanjir();
  },
  beforeDestroy() {
    if (this._onKeyDown) {
      document.removeEventListener("keydown", this._onKeyDown, true);
      this._onKeyDown = null;
    }
    document.removeEventListener("mousedown", this.handleMapDataOutsideClick);
    if (this.map) {
      this.map.remove();

      this.map = null;
    }
  },
};
</script>

<style scoped>
.fh-1 {
  font-variant: all-small-caps;
  line-height: initial;
}
.dropdown-map-data {
  min-width: 480px;
  max-width: 92vw;
}
.matrix-scroll-wrap {
  position: relative;
}
.matrix-scroll-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 22px;
  background: linear-gradient(
    to bottom,
    rgba(27, 30, 33, 0),
    rgba(27, 30, 33, 0.92)
  );
  pointer-events: none;
}
.matrix-scroll {
  max-height: 260px;
  overflow: auto;
}
.matrix-table {
  border-collapse: collapse;
  width: 100%;
}
.matrix-table th,
.matrix-table td {
  padding: 0.25rem 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  white-space: nowrap;
}
.matrix-table thead th {
  position: sticky;
  background: #1b1e21;
  z-index: 5;
}
.matrix-table thead tr:first-child th {
  top: 0;
}
.matrix-table thead tr:nth-child(2) th {
  top: 1.9rem;
}
.type-group-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  font-weight: 600;
  letter-spacing: 0.03em;
}
.district-header:hover,
.col-header:hover {
  background: rgba(255, 255, 255, 0.08);
}
.district-cell {
  font-weight: 500;
  user-select: none;
}
.matrix-row-on > td {
  background: rgba(13, 110, 253, 0.16);
}
.matrix-row-on .district-cell {
  color: #6ea8fe;
}
.cell-toggle {
  cursor: pointer;
  min-width: 2.25rem;
  padding: 0.45rem 0.6rem !important;
  user-select: none;
}
.cell-toggle:hover {
  background: rgba(255, 255, 255, 0.06);
}
.district-toggle {
  white-space: nowrap;
}
.matrix-locked {
  opacity: 0.45;
}
</style>
